module.exports = __webpack_public_path__ + "static/media/promo_3.13f6ddcd.jpg";